import { useLazyQuery } from '@apollo/client'
import { Button, Collapse } from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import RefreshIcon from '@material-ui/icons/Refresh'
import { useState } from 'react'

import PageHeader from '../../components/PageHeader'
import SectionTitle from '../../components/SectionTitle'
import { RESERVE_MONITORING_LIST_QUERY } from '../../graphql/reserveMonitoringList'
import { getTranslate } from '../../localization'
import { EntityList } from '../../types/entityList'
import { ReserveMonitoringListResponse } from '../../types/reserveMonitoringList'
import MonitoringReserveFilters from './MonitoringReserveFilters'
import MonitoringReserveTable from './MonitoringReserveTable'
import useStyles from './styles/index.styles'

const MonitoringReserve = () => {
  const classes = useStyles()
  const [filterButtonSelected, setFilterButtonSelected] =
    useState<boolean>(true)
  const [autoCompleteForAccommodation, setAutoCompleteForAccommodation] =
    useState<any[]>([])

  const [disabledAccs, setDisabledAccs] = useState<boolean>(true)

  const [
    getReserveMonitoringList,
    {
      data: reserveMonitoringData,
      loading: loadingForReserveMonitoringList,
      refetch
    }
  ] = useLazyQuery<{
    reserveMonitoringList: ReserveMonitoringListResponse
  }>(RESERVE_MONITORING_LIST_QUERY, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      const tempSelectedAccommodations = [
        ...data.reserveMonitoringList.pmsAccommodations.map(
          (item: EntityList) => ({
            label: item.label,
            value: item.value
          })
        )
      ]
      setAutoCompleteForAccommodation(tempSelectedAccommodations)
      setDisabledAccs(false)
    }
  })

  const AccommodationIds: string[] = []
  if (autoCompleteForAccommodation && autoCompleteForAccommodation.length > 0) {
    autoCompleteForAccommodation.forEach((acc) => {
      AccommodationIds.push(acc.value)
    })
  }

  return (
    <div>
      <PageHeader title={getTranslate('Reservation Monitoring')} />
      <div className={classes.header}>
        <SectionTitle title="Reservation Monitoring" />
        <div className={classes.buttons}>
          <div className={classes.refresh}>
            <Button
              size={'medium'}
              startIcon={<RefreshIcon />}
              variant="text"
              color="primary"
              onClick={() => refetch()}>
              {getTranslate('Refresh')}
            </Button>
          </div>
          <Button
            size={'medium'}
            startIcon={<FilterListIcon />}
            variant="contained"
            color="primary"
            onClick={() => setFilterButtonSelected(!filterButtonSelected)}>
            {getTranslate('Filter')}
          </Button>
        </div>
      </div>
      <Collapse in={filterButtonSelected}>
        <MonitoringReserveFilters
          autoCompleteForAccommodation={autoCompleteForAccommodation}
          setAutoCompleteForAccommodation={setAutoCompleteForAccommodation}
          getReserveMonitoringList={getReserveMonitoringList}
          loadingForReserveMonitoringList={loadingForReserveMonitoringList}
          accommodations={
            reserveMonitoringData
              ? reserveMonitoringData.reserveMonitoringList.pmsAccommodations
              : []
          }
          disabledAccs={disabledAccs}
          setDisabledAccs={setDisabledAccs}
        />
      </Collapse>
      {((reserveMonitoringData &&
        reserveMonitoringData?.reserveMonitoringList.pmsAccommodations.length >
          0) ||
        loadingForReserveMonitoringList) && (
        <MonitoringReserveTable
          uniqueChannelNames={
            reserveMonitoringData
              ? reserveMonitoringData.reserveMonitoringList.uniqueChannelNames
              : []
          }
          mappedChannelsForAccommodation={
            reserveMonitoringData
              ? reserveMonitoringData?.reserveMonitoringList
                  .mappedChannelsForAccommodation
              : []
          }
          loadingForReserveMonitoringList={loadingForReserveMonitoringList}
          AccommodationIds={AccommodationIds}
        />
      )}
    </div>
  )
}

export default MonitoringReserve
